import { render, staticRenderFns } from "./serviceStatistics.vue?vue&type=template&id=62b49976"
import script from "./serviceStatistics.vue?vue&type=script&lang=js"
export * from "./serviceStatistics.vue?vue&type=script&lang=js"
import style0 from "./serviceStatistics.vue?vue&type=style&index=0&id=62b49976&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports